export const common = {
  // Navigation
  'nav.features': 'विशेषताएं',
  'nav.howItWorks': 'यह कैसे काम करता है',
  'nav.pricing': 'मूल्य निर्धारण',
  'nav.faq': 'सामान्य प्रश्न',
  'nav.aboutUs': 'हमारे बारे में',
  'nav.getStarted': 'शुरू करें',

  // About Us Section
  'aboutUs.badge': 'हमारे बारे में',
  'aboutUs.title': 'हमारे बारे में',
  'aboutUs.line1': 'विचार सस्ते हैं।',
  'aboutUs.line2': 'पूंजी नहीं है। समय और भी कम है।',
  'aboutUs.paragraph1':
    'IdeaOracle.ai इसलिए बनाया गया क्योंकि अधिकांश व्यावसायिक विचार साहस की कमी से नहीं - बल्कि ईमानदारी की कमी से विफल होते हैं। बहुत ज़्यादा पुष्टि। बहुत कम हकीकत।',
  'aboutUs.belief1a': 'हम हाइप में विश्वास नहीं करते।',
  'aboutUs.belief1b': 'हम बाजार तर्क में विश्वास करते हैं।',
  'aboutUs.belief2a': 'हम प्रेरणा में विश्वास नहीं करते।',
  'aboutUs.belief2b': 'हम मांग, प्रतिस्पर्धा और विभेदीकरण में विश्वास करते हैं।',
  'aboutUs.mission1': 'हमारा काम विचारों को अच्छा दिखाना नहीं है।',
  'aboutUs.mission2': 'हमारा काम उनकी व्यवहार्यता को उजागर करना है।',
  'aboutUs.analysis':
    'IdeaOracle.ai व्यावसायिक निचेस का संरचनात्मक बाजार यांत्रिकी, यथार्थवादी मांग, प्रतिस्पर्धी तीव्रता और व्यवहार्यता के लिए विश्लेषण करता है। भावनात्मक नहीं। आशावादी नहीं। बल्कि संयमित।',
  'aboutUs.failure1': 'अधिकांश विचार विफल होते हैं।',
  'aboutUs.failure2': 'इसलिए नहीं कि संस्थापक अक्षम हैं -',
  'aboutUs.failure3': 'बल्कि इसलिए कि पहले से कोई पर्याप्त स्पष्ट नहीं था।',
  'aboutUs.clarity': 'हम वह स्पष्टता प्रदान करने के लिए मौजूद हैं।',
  'aboutUs.value1': 'असुविधाजनक।',
  'aboutUs.value2': 'सीधा।',
  'aboutUs.value3': 'सुसंगत।',
  'aboutUs.confirm': 'यदि किसी विचार में सार है, तो हम उसकी पुष्टि करते हैं।',
  'aboutUs.deny': 'यदि नहीं, तो हम ऐसा भी कहते हैं।',
  'aboutUs.noApplause': 'तालियों के बिना।',
  'aboutUs.noSugarcoating': 'चीनी के आवरण के बिना।',
  'aboutUs.noTheater': 'रंगमंच के बिना।',
  'aboutUs.closingTagline': 'कोई हाइप नहीं। केवल सच्चाई।',

  // Hero Section
  'hero.badge': 'व्यावसायिक निचे के लिए निर्णय AI',
  'hero.title1': 'विचार सस्ते हैं।',
  'hero.title2': 'गलत निर्णय नहीं हैं।',
  'hero.subtitle': 'एक AI जो आपके व्यावसायिक निचे का मूल्यांकन करता है',
  'hero.subtitleLine2': 'इससे पहले कि आप निवेश करें।',
  'hero.cta': 'विचार जांचें',
  'hero.ctaSecondary': 'यह कैसे काम करता है',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'प्रति अनुरोध क्रेडिट',
  'hero.stat2Value': '7+',
  'hero.stat2Label': 'रेटिंग स्तर',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'ईमानदार और निजी',
  'hero.trialTitle': 'अपना नि:शुल्क ट्रायल शुरू करें',
  'hero.creditsLabel': 'क्रेडिट',
  'hero.trialTagline': 'हमारे AI सहायक को 3 दिन नि:शुल्क आज़माएं',
  'hero.trialCta': 'साइन अप करें और 250 क्रेडिट पाएं',
  'hero.trialNoCard': 'क्रेडिट कार्ड की आवश्यकता नहीं। कोई प्रतिबद्धता नहीं।',

  // Features Section
  'features.title1': 'शक्तिशाली सुविधाएं',
  'features.title2': 'आधुनिक',
  'features.title3': 'व्यवसायों के लिए',
  'features.honestVerdict.title': 'हाइप स्कोर नहीं, ईमानदार फैसला',
  'features.honestVerdict.description': 'वास्तविक बाज़ार डेटा और प्रतियोगी शोध पर आधारित स्पष्ट अच्छा/मध्यम/कमज़ोर फैसले। हर विचार की चापलूसी करने वाली 9/10 रेटिंग नहीं।',
  'features.fullJourney.title': 'आइडिया चेक से Builder Report तक',
  'features.fullJourney.description': 'चैट में सत्यापित करें, बाज़ार विश्लेषण में गहराई से जाएँ, 25–75 पेज Builder Report एक्सपोर्ट करें — personas, वित्त, go-to-market और pitch deck के साथ।',
  'features.multilingual.title': '21 भाषाएँ, स्थानीय बाज़ार डेटा',
  'features.multilingual.description': 'स्विस SME से लेकर साओ पाउलो के सोलो फाउंडर तक — AI आपकी भाषा में, आपके बाज़ार के स्रोतों के साथ जवाब देता है।',

  // How It Works
  'howItWorks.title': 'यह कैसे काम करता है',
  'howItWorks.subtitle': 'अपने व्यावसायिक निचे के बारे में स्पष्टता के लिए चार कदम।',
  'howItWorks.step1Title': 'एक योजना चुनें',
  'howItWorks.step1Desc': 'Starter, Pro या Builder - आपकी समीक्षा की गहराई के आधार पर।',
  'howItWorks.step2Title': 'AI से पूछें',
  'howItWorks.step2Desc': 'निचे के बारे में अपने प्रश्न पूछें। प्रत्येक अनुरोध में 30 क्रेडिट खर्च होते हैं।',
  'howItWorks.step3Title': 'ईमानदार फैसला प्राप्त करें',
  'howItWorks.step3Desc': 'AI रेटिंग देता है: अच्छा, मध्यम या खराब। बिना सजावट के।',
  'howItWorks.step4Title': 'निर्णय लें',
  'howItWorks.step4Desc': 'अब आप जानते हैं कि आगे बढ़ना उचित है या नहीं।',

  // Pricing
  'pricing.title': 'मूल्य निर्धारण',
  'pricing.subtitle': 'अपनी समीक्षा की गहराई के अनुरूप योजना चुनें।',
  'pricing.yearlyDiscount': 'वार्षिक सदस्यता:',
  'pricing.yearlyDiscountValue': '-20% छूट',
  'pricing.perMonth': 'प्रति माह',
  'pricing.selectPlan': 'योजना चुनें',
  'pricing.mostPopular': 'सबसे लोकप्रिय',
  'pricing.footer': 'सभी कीमतें CHF में हैं। क्रेडिट केवल सफल AI प्रतिक्रियाओं के लिए काटे जाते हैं।',
  
  'pricing.billedYearly': 'वार्षिक बिलिंग',
  'pricing.savings': 'बचत',
  'pricing.monthly': 'मासिक',
  'pricing.yearly': 'वार्षिक',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3 दिन नि:शुल्क पहुंच',
  'pricing.trial.credits': '250 क्रेडिट',
  'pricing.trial.free': 'नि:शुल्क',
  'pricing.trial.duration': '3 दिनों के लिए मुफ्त',
  'pricing.trial.cta': 'नि:शुल्क ट्रायल शुरू करें',
  'pricing.trial.feature1': 'AI को आज़माने के लिए 250 क्रेडिट',
  'pricing.trial.feature2': '3 दिनों के लिए पूर्ण पहुंच',
  'pricing.trial.feature3': 'क्रेडिट कार्ड की आवश्यकता नहीं',
  'pricing.trial.feature4': 'कभी भी रद्द करें',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10,000 क्रेडिट + 25-पेज Builder रिपोर्ट',
  'pricing.gold.credits': '10,000 क्रेडिट',
  'pricing.gold.feature1': '10,000 क्रेडिट',
  'pricing.gold.feature2': '25-पेज Builder रिपोर्ट',
  'pricing.gold.feature3': 'सभी Starter और Pro सुविधाएं',
  'pricing.gold.feature4': 'बाजार विश्लेषण और सारांश',
  'pricing.gold.feature5': 'अवसर, जोखिम, सिफारिशें',
  'pricing.gold.feature6': 'PDF डाउनलोड करें',
  'pricing.gold.feature7': 'समर्थन',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15,000 क्रेडिट + 100-पेज Builder रिपोर्ट',
  'pricing.platinum.credits': '15,000 क्रेडिट',
  'pricing.platinum.feature1': '15,000 क्रेडिट',
  'pricing.platinum.feature2': '100-पेज Builder रिपोर्ट',
  'pricing.platinum.feature3': 'सभी Gold सुविधाएं',
  'pricing.platinum.feature4': 'Builder मोड: डेवलपर ब्रीफिंग',
  'pricing.platinum.feature5': 'संरचित सारांश',
  'pricing.platinum.feature6': 'उन्नत बाजार विश्लेषण',
  'pricing.platinum.feature7': 'समर्थन',

  // Admin
  'admin.dashboard.tabs.plans': 'योजनाएं',

  // Credit top-up
  'dashboard.credits.topup.button': 'क्रेडिट टॉप-अप करें',
  'dashboard.credits.topup.buttonTitle': 'योजना बदले बिना अधिक क्रेडिट खरीदें',
  'dashboard.credits.topup.title': 'क्रेडिट टॉप-अप करें',
  'dashboard.credits.topup.subtitle': 'CHF 0.15 प्रति क्रेडिट — योजना बदलने की आवश्यकता नहीं',
  'dashboard.credits.topup.quickAmounts': 'त्वरित चयन',
  'dashboard.credits.topup.custom': 'कस्टम',
  'dashboard.credits.topup.totalLabel': 'कुल',
  'dashboard.credits.topup.creditsLabel': 'क्रेडिट',
  'dashboard.credits.topup.confirm': 'अभी खरीदें',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'प्रारंभिक वास्तविकता परीक्षणों के लिए।',
  'pricing.starter.credits': '2,500 क्रेडिट',
  'pricing.starter.feature1': 'निचे विचार उत्पन्न करें',
  'pricing.starter.feature2': 'निचे को परिष्कृत करें',
  'pricing.starter.feature3': 'बाजार वास्तविकता जांच',
  'pricing.starter.feature4': 'प्रतिस्पर्धा मूल्यांकन',
  'pricing.starter.feature5': 'समय मूल्यांकन',
  'pricing.starter.feature6': 'ईमानदार फैसला',
  'pricing.starter.feature7': 'निजी सत्र',
  'pricing.starter.feature8': 'इतिहास और निर्यात',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'गहरी समीक्षा के लिए।',
  'pricing.pro.credits': '5,000 क्रेडिट',
  'pricing.pro.feature1': 'सभी Starter सुविधाएं',
  'pricing.pro.feature2': 'गहन समीक्षा के लिए अधिक क्रेडिट',
  'pricing.pro.feature3': 'सुधार सुझाव',
  'pricing.pro.feature4': 'वैकल्पिक निचेस',
  'pricing.pro.feature5': 'विस्तृत बाजार विश्लेषण',
  'pricing.pro.feature6': 'प्राथमिकता समर्थन',
  'pricing.pro.feature7': 'उन्नत फ़िल्टर',
  'pricing.pro.feature8': 'सत्र पसंदीदा',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'विचार → डेवलपर ब्रीफिंग।',
  'pricing.builder.credits': 'असीमित क्रेडिट',
  'pricing.builder.feature1': 'सभी Pro सुविधाएं',
  'pricing.builder.feature2': 'असीमित AI अनुरोध',
  'pricing.builder.feature3': 'Builder मोड: डेवलपर ब्रीफिंग',
  'pricing.builder.feature4': 'संरचित परियोजना अवलोकन',
  'pricing.builder.feature5': 'उपयोगकर्ता प्रवाह और मुख्य कार्य',
  'pricing.builder.feature6': 'तकनीकी नोट्स',
  'pricing.builder.feature7': 'गैर-लक्ष्यों को परिभाषित करें',
  'pricing.builder.feature8': 'उचित उपयोग दर सीमा',
  'pricing.builder.limitNote': 'उचित उपयोग सीमा',
  'pricing.monthlyReset': 'मासिक रीसेट',

  // Modal
  'pricing.modal.selected': 'चयनित',
  'pricing.modal.comingSoon': 'पंजीकरण और भुगतान प्रसंस्करण जल्द ही उपलब्ध होगा।',
  'pricing.modal.patience': 'हम आपको एक सुरक्षित और निर्बाध अनुभव प्रदान करने के लिए काम कर रहे हैं। कृपया धैर्य रखें।',
  'pricing.modal.understood': 'समझ गया',

  // FAQ
  'faq.title': 'अक्सर पूछे जाने वाले प्रश्न',
  'faq.subtitle': 'ईमानदारी और आलोचनात्मक रूप से उत्तर दिया गया।',
  'faq.q1': 'IdeaOracle.ai वास्तव में क्या करता है?',
  'faq.a1': 'IdeaOracle.ai व्यावसायिक विचारों और निचेस का बाजार तर्क, वास्तविक मांग, प्रतिस्पर्धा, विभेदीकरण और व्यवहार्यता के लिए मूल्यांकन करता है।\nयदि सार है, तो हम दिखाते हैं कि इसे रणनीतिक रूप से कैसे तेज किया जा सकता है।\nयदि नहीं, तो हम कहते हैं।',
  'faq.q2': 'क्या आप विचार भी उत्पन्न करते हैं?',
  'faq.a2': 'हां।\nलेकिन अंधाधुंध नहीं।\nहम बाजार तर्क पर आधारित दृष्टिकोण विकसित करते हैं – प्रेरणा या ट्रेंड हाइप पर नहीं।',
  'faq.q3': 'क्या आप व्यवसाय मॉडल को अनुकूलित करते हैं?',
  'faq.a3': 'हां – यदि क्षमता है।\nहम भ्रम को चमकाते नहीं हैं।\nहम व्यवहार्य अवधारणाओं को अधिक लचीला बनाते हैं।',
  'faq.q4': 'आपको अन्य AI टूल्स से क्या अलग करता है?',
  'faq.a4': 'अन्य टूल्स प्रेरणा देते हैं।\nहम मूल्यांकन देते हैं।\nध्यान यथार्थवाद पर है, उत्साह पर नहीं।',
  'faq.q5': 'क्या यह सफलता की गारंटी है?',
  'faq.a5': 'नहीं।\nहम गलत निर्णयों को कम करते हैं – जोखिम को समाप्त नहीं करते।',
  'faq.q6': 'IdeaOracle.ai किसके लिए है?',
  'faq.a6': 'शुरुआत से पहले संस्थापक\nविस्तार से पहले उद्यमी\nसमय निवेश से पहले साइड-बिल्डर\nजांच से पहले निवेशक\n\nसंक्षेप में: उन लोगों के लिए जो पूंजी से पहले स्पष्टता चाहते हैं।',
  'faq.q7': 'अगर मैं सिर्फ पुष्टि खोज रहा हूं?',
  'faq.a7': 'तो IdeaOracle.ai सही टूल नहीं है।',
  'faq.q8': 'विश्लेषण कितना ईमानदार है?',
  'faq.a8': 'उतना ईमानदार जितना डेटा और बाजार यांत्रिकी अनुमति देती है।\nकोई उत्साह नहीं। कोई दया नहीं।',
  'faq.q9': 'क्या आप बाजार अनुसंधान की जगह लेते हैं?',
  'faq.a9': 'नहीं।\nहम एक रणनीतिक पूर्व-मूल्यांकन हैं – पूर्ण बाजार अध्ययन नहीं।',
  'faq.q10': 'इतने समझौताहीन क्यों?',
  'faq.a10': 'क्योंकि विफलता महंगी है।\nईमानदारी नहीं।',

  // Footer
  'footer.description': 'यह प्लेटफ़ॉर्म आपको अच्छा महसूस कराने में मदद नहीं करता - बल्कि सही निर्णय लेने में मदद करता है।',
  'footer.product': 'उत्पाद',
  'footer.aiAssistant': 'AI सहायक',
  'footer.howItWorks': 'यह कैसे काम करता है',
  'footer.pricing': 'मूल्य निर्धारण',
  'footer.faq': 'अक्सर पूछे जाने वाले प्रश्न',
  'footer.legal': 'कानूनी',
  'footer.privacy': 'गोपनीयता',
  'footer.terms': 'शर्तें',
  'footer.imprint': 'छाप',
  'footer.support': 'समर्थन',
  'footer.contact': 'संपर्क',
  'footer.documentation': 'दस्तावेज़ीकरण',
  'footer.copyright': '© 2025 IdeaOracle.ai. सर्वाधिकार सुरक्षित।',

  // AI Assistant
  'aiAssistant.title': 'AI निचे सहायक',
  'aiAssistant.subtitle': 'निचेस के बारे में प्रश्न',
  'aiAssistant.welcomeMessage': 'नमस्ते! अपने विचार का वर्णन करें या मुझसे एक निचे के बारे में पूछें। मैं आपको एक स्पष्ट और ईमानदार मूल्यांकन दूंगा।',
  'aiAssistant.demoResponse': 'यह एक डेमो है। वास्तविक AI मूल्यांकन प्राप्त करने के लिए, कृपया पंजीकरण करें और एक योजना चुनें।',
  'aiAssistant.placeholder': 'अपने विचार का वर्णन करें...',

  // Header & Sidebar
  'dashboard.header.title': 'डैशबोर्ड',
  'dashboard.sidebar.overview': 'अवलोकन',
  'dashboard.sidebar.newAnalysis': 'AI सहायक',
  'dashboard.sidebar.history': 'इतिहास',
  'dashboard.sidebar.credits': 'क्रेडिट',
  'dashboard.sidebar.settings': 'सेटिंग्स',

  // Dashboard Overview
  'dashboard.overview.welcome': 'वापसी पर स्वागत है, {{name}}',
  'dashboard.overview.subtitle': 'यहां आपकी गतिविधि का त्वरित अवलोकन है',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'शेष क्रेडिट',
  'dashboard.stats.totalAnalyses': 'कुल विश्लेषण',
  'dashboard.stats.goodRatings': 'सकारात्मक रेटिंग',
  'dashboard.stats.nextReset': 'अगला रीसेट',
  'dashboard.stats.days': 'दिन',

  // Quick Actions
  'dashboard.quickActions.title': 'त्वरित क्रियाएं',
  'dashboard.quickActions.checkNewIdea': 'एक विचार जांचें',
  'dashboard.quickActions.checkNewIdeaDesc': 'मौजूदा व्यावसायिक विचार का विश्लेषण करें',
  'dashboard.quickActions.generateIdea': 'एक विचार उत्पन्न करें',
  'dashboard.quickActions.generateIdeaDesc': 'एक नया लाभदायक निचे खोजें',
  'dashboard.quickActions.builderBriefing': 'Builder ब्रीफिंग',
  'dashboard.quickActions.builderBriefingDesc': 'एक विचार को डेवलपर-तैयार ब्रीफिंग में बदलें',
  'dashboard.quickActions.premiumOnly': 'केवल Builder',

  // Chat Header
  'chat.title': 'AI निचे सहायक',
  'chat.subtitle': 'निचेस के बारे में प्रश्न पूछें। मैं आलोचनात्मक और ईमानदारी से मूल्यांकन करता हूं।',
  'chat.creditsLabel': 'क्रेडिट',

  // Chat Welcome
  'chat.welcomeTitle': 'AI निचे सहायक में आपका स्वागत है',
  'chat.welcomeDesc': 'अपने विचार का वर्णन करें या एक निचे के बारे में पूछें। मैं ईमानदारी से मूल्यांकन करूंगा: अच्छा, मध्यम या खराब।',
  'chat.aiWelcome': 'नमस्ते! अपने विचार का वर्णन करें या मुझसे एक निचे के बारे में पूछें। मैं आपको एक स्पष्ट और ईमानदार मूल्यांकन दूंगा।',

  // Chat Suggestions
  'chat.suggestion1': 'मुझे एक लाभदायक निचे खोजें।',
  'chat.suggestion2': 'मेरे पास एक विचार है - इसे ईमानदारी से मूल्यांकन करें।',
  'chat.suggestion3': 'अभी किन निचेस में क्षमता है?',
  'chat.suggestion4': 'इस निचे को परिष्कृत करें और इसे अधिक विशिष्ट बनाएं।',

  // Chat Actions
  'chat.newConversation': 'नई बातचीत',
  'chat.today': 'आज',
  'chat.yesterday': 'कल',
  'chat.thisWeek': 'इस सप्ताह',
  'chat.thisMonth': 'इस महीने',
  'chat.older': 'पुराना',
  'chat.messages': 'संदेश',
  'chat.renameConversation': 'नाम बदलें',
  'chat.deleteConversation': 'हटाएं',
  'chat.cancel': 'रद्द करें',
  'chat.rename': 'नाम बदलें',
  'chat.delete': 'हटाएं',
  'chat.favorite': 'पसंदीदा में जोड़ें',
  'chat.unfavorite': 'पसंदीदा से हटाएं',
  'chat.searchSessions': 'बातचीत खोजें...',
  'chat.noResults': 'कोई परिणाम नहीं मिला',
  'chat.noSessions': 'अभी तक कोई बातचीत नहीं',
  'chat.enterNewName': 'नया नाम दर्ज करें...',
  'chat.deleteConfirmMessage': 'क्या आप वाकई इस बातचीत को हटाना चाहते हैं? इस क्रिया को पूर्ववत नहीं किया जा सकता।',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'अपना प्रश्न टाइप करें… (30 क्रेडिट खर्च होते हैं)',
  'chat.send': 'भेजें',
  'chat.voice': 'बोलें',
  'chat.listeningPlaceholder': 'मैं सुन रहा हूं... अभी बोलें।',
  'chat.stopListening': 'रिकॉर्डिंग बंद करें',
  'chat.recording': 'रिकॉर्ड हो रहा है...',
  'chat.speechNotSupported': 'आपके ब्राउज़र द्वारा वाक् पहचान समर्थित नहीं है।',
  'chat.microphonePermissionDenied': 'माइक्रोफ़ोन एक्सेस अस्वीकृत। कृपया अपनी ब्राउज़र सेटिंग्स में एक्सेस की अनुमति दें।',
  'chat.errorNotEnoughCredits': 'पर्याप्त क्रेडिट नहीं। कृपया अपनी योजना अपग्रेड करें या अगले रीसेट की प्रतीक्षा करें।',
  'chat.errorAiFailed': 'AI प्रतिक्रिया विफल रही। कोई क्रेडिट नहीं काटा गया।',
  'chat.errorRateLimit': 'बहुत अधिक अनुरोध। कृपया एक क्षण प्रतीक्षा करें।',

  // Ratings
  'rating.good': 'अच्छा',
  'rating.medium': 'मध्यम',
  'rating.bad': 'खराब',

  // Auth Page
  'auth.branding.headline1': 'हर विचार अच्छा नहीं होता।',
  'auth.branding.headline2': 'हम ईमानदारी से बताते हैं।',
  'auth.branding.subtitle': 'व्यावसायिक निचेस के लिए एक निर्णय AI। स्पष्ट। आलोचनात्मक। बिना सजावट के।',
  'auth.benefits.privacy.title': '100% निजी',
  'auth.benefits.privacy.desc': 'आपके विचार पूरी तरह से निजी और सुरक्षित रहते हैं।',
  'auth.benefits.honest.title': 'ईमानदार AI',
  'auth.benefits.honest.desc': 'बिना सजावट के – केवल स्पष्ट, आलोचनात्मक प्रतिक्रिया।',
  'auth.benefits.fast.title': 'तेज़ परिणाम',
  'auth.benefits.fast.desc': 'मिनटों में अपने निचे के बारे में स्पष्टता प्राप्त करें।',
  'auth.trust.users': 'सक्रिय उपयोगकर्ता',
  'auth.trust.ideas': 'विश्लेषित विचार',
  'auth.trust.rating': 'रेटिंग',
  'auth.login.title': 'लॉगिन',
  'auth.login.headline': 'वापसी पर स्वागत है',
  'auth.login.subtitle': 'अपनी यात्रा जारी रखने के लिए लॉगिन करें।',
  'auth.login.forgotPassword': 'पासवर्ड भूल गए?',
  'auth.login.submit': 'लॉगिन करें',
  'auth.login.noAccount': 'खाता नहीं है?',
  'auth.login.signUp': 'साइन अप करें',
  'auth.register.title': 'साइन अप',
  'auth.register.headline': 'अपना खाता बनाएं',
  'auth.register.subtitle': 'आज ही अपने व्यावसायिक विचारों का विश्लेषण शुरू करें।',
  'auth.register.submit': 'खाता बनाएं',
  'auth.register.hasAccount': 'पहले से खाता है?',
  'auth.register.signIn': 'लॉगिन करें',
  'auth.fields.name': 'पूरा नाम',
  'auth.fields.email': 'ईमेल पता',
  'auth.fields.password': 'पासवर्ड',
  'auth.fields.confirmPassword': 'पासवर्ड की पुष्टि करें',
  'auth.fields.selectPlan': 'अपनी योजना चुनें',
  'auth.placeholders.name': 'अपना नाम दर्ज करें',
  'auth.placeholders.email': 'अपना ईमेल दर्ज करें',
  'auth.placeholders.password': 'अपना पासवर्ड दर्ज करें',
  'auth.placeholders.confirmPassword': 'अपने पासवर्ड की पुष्टि करें',
  'auth.terms.accept': 'मैं स्वीकार करता/करती हूं',
  'auth.terms.terms': 'नियम और शर्तें',
  'auth.privacy.accept': 'मैं स्वीकार करता/करती हूं',
  'auth.privacy.policy': 'गोपनीयता नीति',
  'auth.errors.nameRequired': 'नाम आवश्यक है',
  'auth.errors.emailRequired': 'ईमेल आवश्यक है',
  'auth.errors.emailInvalid': 'कृपया एक वैध ईमेल दर्ज करें',
  'auth.errors.passwordRequired': 'पासवर्ड आवश्यक है',
  'auth.errors.passwordLength': 'पासवर्ड कम से कम 8 अक्षर का होना चाहिए',
  'auth.errors.passwordMismatch': 'पासवर्ड मेल नहीं खाते',
  'auth.loading': 'कृपया प्रतीक्षा करें...',
  'auth.or': 'या जारी रखें',
  'auth.social.google': 'Google से जारी रखें',
  'auth.social.apple': 'Apple से जारी रखें',
  'footer.disclaimer': 'अस्वीकरण',
  'legal.backToHome': 'मुखपृष्ठ पर वापस जाएँ',
  'legal.lastUpdated': 'अंतिम अद्यतन',
  'legal.allRightsReserved': 'सर्वाधिकार सुरक्षित।',
  'legal.authoritativeNotice': 'आपकी भाषा में स्थानीयकृत संस्करण अभी उपलब्ध नहीं है। नीचे कानूनी रूप से बाध्यकारी अंग्रेज़ी मूल पाठ दिखाया गया है।',
  'legal.translationNotice': 'यह सुविधा के लिए अनुवाद है। कानूनी रूप से बाध्यकारी मूल अंग्रेज़ी संस्करण है।',
};

export default common;
